import { motion } from 'framer-motion';

/**
 * Non-interactive cinematic overlay.
 *
 * Layers a vignette and a mission banner above the canvas. Purely visual —
 * never captures pointer events. Motion is gated by prefers-reduced-motion
 * via the global stylesheet (see styles/globals.css).
 */
export function CinematicOverlay(): JSX.Element {
  return (
    <>
      {/* Vignette */}
      <div
        aria-hidden="true"
        style={{
          position: 'fixed',
          inset: 0,
          pointerEvents: 'none',
          zIndex: 10,
          background:
            'radial-gradient(ellipse at center, rgba(0,0,0,0) 55%, rgba(0,0,0,0.55) 100%)',
        }}
      />

      {/* Scanline / grid */}
      <div
        aria-hidden="true"
        style={{
          position: 'fixed',
          inset: 0,
          pointerEvents: 'none',
          zIndex: 11,
          backgroundImage:
            'linear-gradient(rgba(110,231,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(110,231,255,0.04) 1px, transparent 1px)',
          backgroundSize: '64px 64px',
          mixBlendMode: 'screen',
          opacity: 0.5,
        }}
      />

      {/* Mission banner */}
      <motion.div
        initial={{ y: 24, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.7, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
        aria-hidden="true"
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          padding: '14px 28px',
          pointerEvents: 'none',
          zIndex: 12,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontFamily: 'JetBrains Mono, ui-monospace, monospace',
          fontSize: 10.5,
          letterSpacing: '0.32em',
          textTransform: 'uppercase',
          color: 'rgba(110, 231, 255, 0.75)',
          background:
            'linear-gradient(to top, rgba(4,6,10,0.85) 0%, rgba(4,6,10,0) 100%)',
        }}
      >
        <span>MISSION // THE INVISIBLE WEB</span>
        <span>STREAM ONLINE</span>
        <span>UTC SYNC</span>
      </motion.div>
    </>
  );
}
